import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { bootstrapAuth, type AuthUser } from "./lib/api";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { TestsList } from "./pages/TestsList";
import { TestWizard } from "./pages/TestWizard";
import { TestReport } from "./pages/TestReport";
import { SeedAccounts } from "./pages/SeedAccounts";
import { SendingAccounts } from "./pages/SendingAccounts";
import { SendingAccountDetail } from "./pages/SendingAccountDetail";
import { Templates } from "./pages/Templates";
import { Monitoring } from "./pages/Monitoring";
import { AlertsPage } from "./pages/Alerts";
import { AdminPage } from "./pages/Admin";
import { Reports } from "./pages/Reports";
import { Spinner } from "./components/ui";

export function App() {
  const [user, setUser] = useState<AuthUser | null | undefined>(undefined);
  const location = useLocation();

  useEffect(() => {
    bootstrapAuth().then(({ user }) => setUser(user));
  }, []);

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner label="Loading workspace…" />
      </div>
    );
  }

  if (!user) {
    return <Login onLogin={setUser} />;
  }

  return (
    <Layout user={user}>
      <Routes location={location}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/tests" element={<TestsList />} />
        <Route path="/tests/new" element={<TestWizard />} />
        <Route path="/tests/:testId/runs/:runId" element={<TestReport />} />
        <Route path="/monitoring" element={<Monitoring />} />
        <Route path="/accounts/seeds" element={<SeedAccounts />} />
        <Route path="/accounts/sending" element={<SendingAccounts />} />
        <Route path="/accounts/sending/:id" element={<SendingAccountDetail />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/admin/*" element={<AdminPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  );
}
